import { jsx as _jsx } from "react/jsx-runtime";
function createObserverTreeRenderItem(Observer, mapNode) {
    const renderItem = (createTreeNode, _TreeNode, node)=>/*#__PURE__*/ _jsx(Observer, {
            children: ()=>createTreeNode(node, mapNode?.(node))
        }, node.id);
    return renderItem;
}
export { createObserverTreeRenderItem };
